import React, { useState } from 'react';
import { Icons, LandingIcon } from '@/assets';
import { Icon } from '@/components/Icon';
import { createPortal } from 'react-dom';
import Modal from '@/ctComponents/Modal';
import { socialMediaData } from '@/constants';

export const ContactSupport = () => {
  const [showContactDetailsModal, setShowContactDetailsModal] = useState(false);
  return (
    <>
      <div
        className="lg:w-72 w-full"
        style={{
          marginTop: '4.8rem',
        }}>
        <div className="border border-border-tertiary border-solid rounded-lg p-4 ">
          <div className="flex flex-col gap-4">
            <div
              className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-yellow"
              style={{
                background:
                  'linear-gradient(60deg, #FF8C21 13.4%, #FAC74D 86.6%)',
              }}>
              <Icon src={Icons.contactSupport} className="w-5 h-5" />
            </div>

            <div className="flex flex-col gap-3">
              <h3 className="text-xl font-bold m-0 text-primary-text">
                Contact Support
              </h3>
              <p className="text-base m-0 text-secondary-text capitalize ">
                Get personalized help from our support team for issues
              </p>
            </div>

            <div className="flex flex-col gap-2">
              {/* <button className="bg-primary-text cursor-pointer shadow-none border-none font-averta font-bold hover:bg-gray-6000 h-10 rounded flex items-center justify-center gap-2 text-white text-sm -bold transition-colors">
                Send Message
                <Icon src={Icons.sendMessage} className="w-5 h-5" />
              </button> */}
              <button
                onClick={() => setShowContactDetailsModal(true)}
                className="bg-primary-text cursor-pointer shadow-none border-none font-averta font-bold hover:bg-gray-6000 h-10 rounded flex items-center justify-center gap-2 text-white text-sm -bold transition-colors">
                View Contact Details
                <Icon
                  src={Icons.phoneProfile}
                  className="w-5 h-5"
                  color="#fff"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      {createPortal(
        <Modal
          minWidth={477}
          show={showContactDetailsModal}
          children={
            <div
              className="flex flex-col justify-between relative bg-cover bg-no-repeat "
              style={{
                backgroundImage: `url(${LandingIcon.pattern})`,
              }}>
              <div>
                <p className="mt-5 mb-4 text-gray-1000 text-base">
                  You can contact SmartTurn anytime we’re always ready to
                  assist.
                </p>

                <div className={` px-2 pb-2 lg:p-0 `}>
                  <div className="flex items-center gap-4 py-3">
                    <span className="w-12 h-12 rounded-lg  bg-white flex items-center justify-center shadow-small-square">
                      <Icon
                        src={Icons.mapPin}
                        width="24px"
                        height="24px"
                        color="#F2AC4A"
                      />
                    </span>
                    <span className="text-sm text-inactive-text">
                      Location:
                      <br />{' '}
                      <span className="font-bold text-gray-600 ">
                        Los Angeles, USA
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-4 py-3">
                    <span className="w-12 h-12 rounded-lg text-secondary-yellow-dark  bg-white flex items-center justify-center shadow-small-square">
                      <Icon
                        src={Icons.mailProfile}
                        width="24px"
                        height="24px"
                        color="#F2AC4A"
                      />
                    </span>
                    <span className="text-sm text-inactive-text">
                      Email: <br />
                      <a
                        href="mailto:support@smart-turn.com"
                        className=" font-bold no-underline text-gray-600">
                        support@smart-turn.com
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div className=" pt-4  mt-4 mb-6 lg:mb-0 border-t border-solid border-border-tertiary border-l-0 border-r-0 border-b-0">
                <span className=" text-primary-text text-base font-medium">
                  Connect with us:
                </span>
                <div className="flex gap-3 mt-4">
                  {socialMediaData.map((social, index) => (
                    <a
                      key={index}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
                      style={{
                        boxShadow:
                          '0 0 0 1px #EBEBEB, 0 1px 3px 0 rgba(143, 143, 143, 0.20), 0 -2.4px 0 0 rgba(62, 62, 62, 0.04) inset',
                      }}>
                      <Icon src={social.icon} width="40px" height="40px" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          }
          title={'Hi! We are here to help you...'}
          setShow={() => setShowContactDetailsModal(false)}
        />,
        document.body
      )}
    </>
  );
};
